import { Component } from '@angular/core';
import { AngularNodeViewComponent, TiptapNodeViewContentDirective } from 'ngx-tiptap';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-edit-file',
  imports: [MatIcon, MatButton, TiptapNodeViewContentDirective],
  templateUrl: './edit-file-node-view.component.html',
  styleUrl: './edit-file-node-view.component.scss'
})
/**
 * Begründung: Eine Custom AngularNodeComponent um Dateien im Editor rendern zu können
 */
export class EditFileNodeView extends AngularNodeViewComponent {
  private readonly FILE_ICON_MAP: Record<string, string> = {
    doc: 'word',
    docx: 'word',
    txt: 'file',
    mp4: 'play',
    pdf: 'file-pdf',
    image: 'image'
  };

  protected getFileTypeIcon(fileName?: string): string | null {
    if (!fileName) return null;
    const extension = fileName.split('.').pop()?.toLowerCase();
    return this.FILE_ICON_MAP[extension!] || null;
  }

  protected formatFileSize(sizeInBytes: number): string {
    if (sizeInBytes === 0) return '0B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    return `${(sizeInBytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
  }
}
